module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Label_16"],"path":[{"$":{"d":"M6,1H1V6l9.6,9.55,4.95-4.95ZM3,5.49a1.75,1.75,0,1,1,2.47,0A1.75,1.75,0,0,1,3,5.49Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Label_16.svg
// module id = F09v
// module chunks = 1